export default __webpack_public_path__ + "static/media/no-voucher-back.67eb7631.svg";